import * as types from '../constants/DashboardActionTypes';


export const fetchDashboardData = () =>{
  return {
    type: types.DASHBOARD_FETCHING
  }
}